import { resolveUTMAttribution } from '../../universals/utmAttribution';
import resolveGclid from '../../universals/gclidAttribution';

export default function submitQuoteWizard(formData) {
    grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute('6LffqaUrAAAAAJGftssLQNw1Yqz8Ef4FlVNSjYre', { action: 'submitform' });
        async function buildDataObject(data, recaptchaScore) {
            let dataObject = {};
            //New recaptcha Score
            dataObject.recaptchaScore = recaptchaScore
            dataObject.userString = window.navigator.userAgent;
            dataObject.pageURL = window.location.href;
            dataObject.queryString = window.location.search;
            dataObject.refURL = document.referrer || "";
            dataObject.mktoFormId = "1359";
            dataObject.jobTitle = "";
            dataObject.businessPhone = "";
            dataObject.numberOfLeaders = "";
            dataObject.numberOfEmployees = "";
            dataObject.mktoCookie = readCookie('_mkto_trk');
            dataObject.ipAddress = await getIPAddress().then(ip => ip);
            dataObject.gclid = resolveGclid();
            Object.assign(dataObject, resolveUTMAttribution().values);
            dataObject.choices = data.choices.toString();
            dataObject.comments = data.comments;
            dataObject.company = data.company;
            dataObject.country = data.country;
            dataObject.email = data.email;
            dataObject.firstName = data.firstName;
            dataObject.lastName = data.lastName;
            dataObject.formLocationName = "lp-requestQuote";
            dataObject.mutinyFormName = "lp-requestQuote";
            dataObject.source = "";
            dataObject.sourceAdwords = "";
            dataObject.sourceCampaignID = "";
            dataObject.sourceInsight = "";
            dataObject.sourceSocial = "";
            dataObject.subject = "";
            dataObject.GDPR = true;
            if (data.otherText == undefined) {
                dataObject.otherText = null;
            }
            else {
                dataObject.otherText = data.otherText;
            }
            return JSON.stringify(dataObject);
        }

        async function getIPAddress() {
            const url = "/home/GetClientIP";
            const ipFetch = await fetch(url, {
                method: 'GET',
            });
            let ipAddress = await ipFetch.text();
            return ipAddress;
        }
        function readCookie(name) {
            var cookiename = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(cookiename) == 0) return c.substring(cookiename.length, c.length);
            }
            return null;
        }

        function verifyRecaptcha(token) {
            fetch("/recaptcha/validate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(token)
            })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                const score = parseFloat(data["score"]);
                if (score > 0.7) {
                    const postData = async () => {
                        const dataToSubmit = await buildDataObject(formData, score);
                        const url = 'https://prod-18.eastus.logic.azure.com:443/workflows/fdaecea1ff8840d9b619ae0b1f28d2f3/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-F4HzkHXIyCZs6QMssNh9EnF2T2vhUGWiem3CQjmuNM';
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8',
                            },
                            body: dataToSubmit
                        });
                        let result = await response.json();
                        if (response.ok) {
                            document.querySelector('.demo__form__container#form').style.minHeight = '450px';
                            document.querySelector('#quoteWizardContainer').style.display = 'none';
                            document.getElementById('getQuoteFormSuccessContainer').style.display = 'block';
                        }
                        if (result.success) {
                            window.lintrk('track', { conversion_id: 6985714 });
                            window.dataLayer.push({
                                'event': 'form',
                                'formLocation': 'getDemo'
                            });
                        }
                    }
                    postData();
                }
                else {
                    console.log('Recaptch is not verified');
                }
            })
            .catch(error => {
                console.log('Recaptcha validation failed.', error);
            });
        }
        verifyRecaptcha(token);
    });
}